module.exports = __webpack_public_path__ + "static/media/7yw_nl.134887fa.svg";